import { ContattoDTO } from "./contatto-dto";
import { DomicilioDTO } from "./domicilio-dto";

export class DatiRichiedenteDTO {
    contatto: ContattoDTO;
    domicilio: DomicilioDTO;
}